import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';

import { premiumInfoActions } from './actions';
import {
  PREMIUMINFO_FAILURE,
  PREMIUMINFO_REQUEST,
  PUBLICPREMIUMINFO_REQUEST,
  PREMIUMINFO_SUCCESS,
  PREMIUM_PRICING_TIERS_SUCCESS,
  PREMIUM_PRICING_TIERS_REQUEST,
  PREMIUM_PRICING_TIERS_FAILURE,
} from '../../constants/premium';
import { Price } from '../../components/PaymentGateway/interfaces/Price';
import { PremiumProductNames } from '../../components/Shops/Premium/interfaces/PremiumProduct';

export type PremiumPlanPlatforms = 'WEB' | 'MOBILE';

export interface PremiumTemplateData {
  id: string;
  code: keyof typeof PremiumProductNames;
  name: string;
  default_web_price: Price;
  default_pricint_tier_code: string;
}

export interface PremiumPlanData {
  id: string;
  tipster_id: string;
  duration_days: number;
  plan_template_id: string;
  web_price: Price;
  web_price_with_discount: Price;
  web_discount_percentage: number;
  active: boolean;
  created_at: string;
  updated_at: string;
  can_purchase: boolean;
  background_image: string;
  platforms: PremiumPlanPlatforms[];
  in_promotion: boolean;
  pricing_tier_code: string;
  expires_at: string;
}

export type PremiumInfoState = {
  requested: boolean;
  data: any;
  isLoading: boolean;
  tiers: any;
  error: string | null;
};
export type PremiumInfoActions = ActionType<typeof premiumInfoActions>;

export const premiumInfoReducer = combineReducers<
  PremiumInfoState,
  PremiumInfoActions
>({
  requested: (state = false, action) => {
    switch (action.type) {
      case PREMIUMINFO_REQUEST:
      case PUBLICPREMIUMINFO_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (state = [], action) => {
    switch (action.type) {
      case PREMIUMINFO_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  tiers: (state = [], action) => {
    switch (action.type) {
      case PREMIUM_PRICING_TIERS_SUCCESS:
        const { pricing_tiers } = action.payload;
        pricing_tiers.forEach((tier: any) => {
          delete tier.android;
          delete tier.ios;
        });

        return pricing_tiers;
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case PREMIUMINFO_REQUEST:
      case PUBLICPREMIUMINFO_REQUEST:
      case PREMIUM_PRICING_TIERS_REQUEST:
        return true;
      case PREMIUMINFO_FAILURE:
      case PREMIUM_PRICING_TIERS_FAILURE:
        return false;
      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case PREMIUMINFO_FAILURE:
      case PREMIUM_PRICING_TIERS_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
